<template>
    <b-dropdown
        v-model="locale"
        :mobile-modal="false"
        append-to-body
        aria-role="menu"
        class="is-unselectable"
        :class="{ flexible: role === 'webmaster' }"
        position="is-bottom-left"
        @active-change="isActiveLocaleModal = $event">
        <template #trigger>
            <span
                class="navbar-link navbar-item is-arrowless"
                role="button">
                <span class="is-uppercase is-flex is-align-items-center">
                    <!--suppress HtmlUnknownTag -->
                    <flag
                        :iso="ISOLocale(locale)"
                        class="media-left mr-2 is-content-box"> </flag>
                    <span class="locale">
                        {{ locale }}
                    </span>
                </span>
                <b-icon
                    :icon="`chevron-${isActiveLocaleModal ? 'up' : 'down'}`"
                    class="ml-3 locale"> </b-icon>
            </span>
        </template>
        <b-dropdown-item
            :key="locale_"
            v-for="(locale_, index) in $root.$i18n.availableLocales"
            :index="index"
            :value="locale_"
            aria-role="listitem">
            <div class="media is-align-items-center">
                <!--suppress HtmlUnknownTag -->
                <flag
                    :iso="ISOLocale(locale_)"
                    class="media-left"></flag>
                <div class="media-content">
                    <h3>{{ $t(`common.translations.${locale_}`) }}</h3>
                    <small>{{ $t(`common.nativeTranslationLanguages.${locale_}`) }}</small>
                </div>
            </div>
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
  import { mapActions, mapGetters } from "vuex";
  import { UPDATE_LOCALE } from "@core/store/action-constants";

  export default {
    name: "LocalesDropdown",

    data () {
      return {
        isActiveLocaleModal: false
      };
    },

    computed: {
      ...mapGetters(["role"]),

      locale: {
        get () {
          return this.$store.state.locale.locale;
        },

        set (value) {
          this.UPDATE_LOCALE(value);
        }
      }
    },

    methods: {
      ...mapActions([
        UPDATE_LOCALE
      ]),

      /**
       *
       * @param locale: string
       * @return { string }
       * @constructor
       */
      ISOLocale (locale) {
        if (locale === "dev") {
          return "eu";
        } else if (locale === "en") {
          return "us";
        } else {
          return locale;
        }
      }
    }
  };
</script>

<style lang="scss" scoped>
@media (max-width: 1399px) {
  .flexible {
    .locale {
      display: none;
    }
    .navbar-item {
      padding: 0;
    }
  }
}
</style>